import initialState from './state';

import {
  PENDING_STATUS,
  UNDEFINED_STATUS
} from './action-status';

import {
  RESET_STATE,
  SET_NAV_MENU_ITEMS,
  SET_ACTIVE_NAV_MENU_ITEM_ID,
  SET_STORAGE_SPACE,
  SET_SETUP_PASSWORD_STATUS,
  SET_ARCHIVE_DELETION_STATUS,
  SET_CLEANUP_STATUS,
  SET_CONTENT_ITEMS,
  SET_FETCH_NAV_MENU_ITEMS_STATUS,
  SET_FETCH_STORAGE_SPACE_STATUS,
  SET_FETCH_CONTENT_ITEMS_STATUS,
  SET_POST_LOGIN_OPEN_ARCHIVE_ID,
  SET_POST_LOGIN_OPEN_NAV_MENU_ID,
  SET_ACTIVE_CONTENT_TYPE,
  SET_SHARED_CONTENT_ITEMS,
  SET_FETCH_SHARED_CONTENT_ITEMS_STATUS,
  SET_USER_SUBSCRIPTION,
  SET_USER_SUBSCRIPTION_TYPE,
  SET_APP_FEATURES,
  SET_FILE_VERSIONS,
  SET_FETCH_FILE_VERSIONS_STATUS,
  SET_FD_LINK,
  SET_FETCH_FD_LINK_STATUS,
  SET_SIGN_FILE_LINK,
  SET_SIGN_FILE_STATUS,
  SET_SHARED_LINK,
  SET_CREATE_SHARED_LINK_STATUS,
  SET_DELETE_SHARED_LINK_STATUS,
  SET_SHARED_LINK_SETTINGS,
  SET_FETCH_SHARED_LINK_SETTINGS_STATUS,
  SET_UPDATE_SHARED_LINK_SETTINGS_STATUS,
  SET_SEARCH_ENABLED_SATE,
  SET_CLEANUP_BOX_NAME,
  SET_SPACE_FREE_AFTER_CLEANUP,
  SET_CLEANUP_PROGRESS_PERCENT,
  SET_CLEANUP_STAGE,
  SET_SEARCH_RESULT_RECEIVED,
  SET_ACTIVE_VERSION_PATH,
  SET_ACTIVE_VOLUME_PATH,
  SET_ACTIVE_FOLDER_ITEM
} from './mutation-types';

function isNeedChangeStatus(status, newStatus) {
  if (status === UNDEFINED_STATUS) {
    return newStatus === PENDING_STATUS;
  }
  return true;
}

export default {
  [RESET_STATE](state) {
    Object.assign(state, initialState());
  },
  [SET_NAV_MENU_ITEMS](state, navMenuItems) {
    state.navMenuItems = navMenuItems;
  },
  [SET_ACTIVE_NAV_MENU_ITEM_ID](state, activeNavMenuItemId) {
    if (activeNavMenuItemId !== '') {
      state.activeNavMenuItemId = activeNavMenuItemId;
    }
  },
  [SET_STORAGE_SPACE](state, storageSpace) {
    state.storageSpace = storageSpace;
  },
  [SET_SETUP_PASSWORD_STATUS](state, status) {
    if (isNeedChangeStatus(state.setupArchivePasswordStatus, status)) {
      state.setupArchivePasswordStatus = status;
    }
  },
  [SET_ARCHIVE_DELETION_STATUS](state, status) {
    if (isNeedChangeStatus(state.archiveDeletionStatus, status)) {
      state.archiveDeletionStatus = status;
    }
  },
  [SET_CONTENT_ITEMS](state, contentItem) {
    state.contentItems = contentItem;
  },
  [SET_FETCH_NAV_MENU_ITEMS_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchNavMenuItemsStatus, status)) {
      state.fetchNavMenuItemsStatus = status;
    }
  },
  [SET_FETCH_STORAGE_SPACE_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchStorageSpaceStatus, status)) {
      state.fetchStorageSpaceStatus = status;
    }
  },
  [SET_FETCH_CONTENT_ITEMS_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchContentItemsStatus, status)) {
      state.fetchContentItemsStatus = status;
    }
  },
  [SET_POST_LOGIN_OPEN_ARCHIVE_ID](state, archiveId) {
    state.postLoginOpenArchiveId = archiveId;
  },
  [SET_POST_LOGIN_OPEN_NAV_MENU_ID](state, navMenuId) {
    state.postLoginOpenNavMenuId = navMenuId;
  },
  [SET_ACTIVE_CONTENT_TYPE](state, activeContentType) {
    state.activeContentType = activeContentType;
  },
  [SET_SHARED_CONTENT_ITEMS](state, sharedContentItems) {
    state.sharedContentItems = sharedContentItems;
  },
  [SET_FETCH_SHARED_CONTENT_ITEMS_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchSharedContentItemsStatus, status)) {
      state.fetchSharedContentItemsStatus = status;
    }
  },
  [SET_USER_SUBSCRIPTION](state, userSubscription) {
    state.userSubscription = userSubscription;
  },
  [SET_USER_SUBSCRIPTION_TYPE](state, userSubscriptionType) {
    state.userSubscriptionType = userSubscriptionType;
  },
  [SET_APP_FEATURES](state, appFeatures) {
    state.appFeatures = appFeatures;
  },
  [SET_FILE_VERSIONS](state, fileVersions) {
    state.fileVersions = fileVersions;
  },
  [SET_FETCH_FILE_VERSIONS_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchFileVersionsStatus, status)) {
      state.fetchFileVersionsStatus = status;
    }
  },
  [SET_FD_LINK](state, fdLink) {
    state.fdLink = fdLink;
  },
  [SET_FETCH_FD_LINK_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchFdLinkStatus, status)) {
      state.fetchFdLinkStatus = status;
    }
  },
  [SET_SIGN_FILE_LINK](state, signFileLink) {
    state.signFileLink = signFileLink;
  },
  [SET_SIGN_FILE_STATUS](state, status) {
    if (isNeedChangeStatus(state.signFileStatus, status)) {
      state.signFileStatus = status;
    }
  },
  [SET_SHARED_LINK](state, sharedLink) {
    state.sharedLink = sharedLink;
  },
  [SET_CREATE_SHARED_LINK_STATUS](state, status) {
    if (isNeedChangeStatus(state.createSharedLinkStatus, status)) {
      state.createSharedLinkStatus = status;
    }
  },
  [SET_DELETE_SHARED_LINK_STATUS](state, status) {
    if (isNeedChangeStatus(state.deleteSharedLinkStatus, status)) {
      state.deleteSharedLinkStatus = status;
    }
  },
  [SET_SHARED_LINK_SETTINGS](state, sharedLinkSettings) {
    state.sharedLinkSettings = sharedLinkSettings;
  },
  [SET_FETCH_SHARED_LINK_SETTINGS_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchSharedLinkStatus, status)) {
      state.fetchSharedLinkStatus = status;
    }
  },
  [SET_UPDATE_SHARED_LINK_SETTINGS_STATUS](state, status) {
    if (isNeedChangeStatus(state.updateSharedLinkStatus, status)) {
      state.updateSharedLinkStatus = status;
    }
  },
  [SET_SEARCH_ENABLED_SATE](state, searchEnabled) {
    state.searchEnabled = searchEnabled;
  },
  [SET_CLEANUP_BOX_NAME](state, cleanupBoxName) {
    state.cleanupBoxName = cleanupBoxName;
  },
  [SET_SPACE_FREE_AFTER_CLEANUP](state, spaceFreeAfterCleanup) {
    state.spaceFreeAfterCleanup = spaceFreeAfterCleanup;
  },
  [SET_CLEANUP_PROGRESS_PERCENT](state, cleanupProgressPercent) {
    state.cleanupProgressPercent = cleanupProgressPercent;
  },
  [SET_CLEANUP_STATUS](state, cleanupStatus) {
    state.cleanupStatus = cleanupStatus;
  },
  [SET_CLEANUP_STAGE](state, cleanupStage) {
    state.cleanupStage = cleanupStage;
  },
  [SET_SEARCH_RESULT_RECEIVED](state, searchResultReceived) {
    state.searchResultReceived = searchResultReceived;
  },
  [SET_ACTIVE_VERSION_PATH](state, activeVersionPath) {
    state.activeVersionPath = activeVersionPath;
  },
  [SET_ACTIVE_VOLUME_PATH](state, activeVolumePath) {
    state.activeVolumePath = activeVolumePath;
  },
  [SET_ACTIVE_FOLDER_ITEM](state, activeFolderItem) {
    state.activeFolderItem = activeFolderItem;
  }
};

